import React, { useState, useEffect, useRef } from "react";
import ViewworkbookHeader2 from "./Components/ViewworkbookHeader2";
import ViewWBCharts from "./Components/ViewWBCharts";
import LibraryFolderPaths from "../LibraryFolderPaths";
import useAuth from "../../hooks/useAuth";
import { conditionForEditWB } from "../smallFunction/conditionForEditWB";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate, useSearchParams } from "react-router-dom";
import DropDownComp from "../../components/DropDownComp";
import { ImHome } from "react-icons/im";
import {
  useDeleteWorkbookViewMutation,
  useGetAllWorkBookViewsQuery,
  useGetWorkbookQuery,
  useGetWorkbookViewsByWorkbookIdQuery,
  useSaveWorkbookViewMutation,
  useScreenshotFunctionMutation,
  useScreenshotMutation,
} from "../reduxworkbook/dataApiSlice";
import { useDispatch, useSelector, useStore } from "react-redux";
import {
  activeSheetFilters,
  setFiltersForScreenshot,
  setWorkbookData,
} from "../reduxworkbook/WorkbookSlice";
import SubscribeModal from "./Components/SubscribeModal";
import { useMyContext } from "../../MyContext";
import DownloadDataModal from "../DownloadDataModal";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import { Dropdown } from "flowbite-react";
import { MdDownload, MdOutlineDashboard } from "react-icons/md";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { GrDocumentCsv, GrDocumentPdf } from "react-icons/gr";
import { FaRegFileImage } from "react-icons/fa6";
import { takeAndDownloadScreenshotForRechart } from "../smallFunction/SmallFunctions";
import {
  getSheetsWithActiveIndexes,
  setSheetControls,
} from "../reduxworkbook/WorkbookControllingSlice";
import AreYouSureModal from "../reduxworkbook/components/WorkbookComponets/AreYouSureModal";
import { conditionForSavingTheWBView } from "../smallFunction/conditionForSavingTheWBView";
import { store } from "../../app/store";
import { AiOutlineSave } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { setCredentials } from "../auth/authSlice";
export default function ViewWorkbook() {
  const GRID_COLUMNS = 24;
  const { username, roles } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const droppableAreaRef = useRef(null);
  const itemRef = useRef(null);
  const buttonRef = useRef(null);
  const { callFunction, handleDownloadImage, setToast } = useMyContext();
  const [searchParams] = useSearchParams();
  const sheetId = searchParams.get("sheetid");
  const workbookId = searchParams.get("workbookid");
  const isEmbed = searchParams.get("isEmbed") === "true";
  const rawFilters = searchParams.get("filters");
  const rawActiveSheet = searchParams.get("activeSheet");
  const viewId = searchParams.get("viewid");
  const filters = JSON.parse(decodeURIComponent(rawFilters));
  const activeSheet = JSON.parse(decodeURIComponent(rawActiveSheet));

  // console.log(isEmbed);
  // // console.log(activeSheet);
  // // console.log(viewId);
  // // console.log(animationOff);

  let filterBar = false;
  let animationOff = false;
  if (searchParams.get("filterbar")) {
    if (searchParams.get("filterbar") === "true") {
      filterBar = true;
    } else if (searchParams.get("filterbar") === "false") {
      filterBar = false;
    }
  }
  if (searchParams.get("animationOff")) {
    if (searchParams.get("animationOff") === "true") {
      animationOff = true;
    } else if (searchParams.get("animationOff") === "false") {
      animationOff = false;
    }
  }
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [gridSize, setGridSize] = useState(25);
  const [filterSideBar, setFilterSideBar] = useState(filterBar || false);
  const [currentSheet, setCurrentSheet] = useState(null);
  const [downloadDataModal, setDownloadDataModal] = useState(false);
  const [viewPublishedButton, setViewPublishedButton] = useState(false);

  const handleCallFunction = (id, downloadType, imageFormat) => {
    if (id) {
      callFunction(id, downloadType, imageFormat);
    } else {
      console.error(
        `something went wrong while downloading the data try again later`
      );
    }
  };
  const snapToGrid = (value, gridSize) => {
    const convertedPixels = Math.max(0, value * gridSize);
    return convertedPixels;
  };

  const handleDownloadDataModal = () => {
    setDownloadDataModal(true);
  };
  // get original workbook
  const {
    data: workbookData,
    isError: isWorkbookError,
    isLoading: isWorkbookLoading,
    isSuccess: isWorkbookSuccess,
    error: workbookError,
  } = useGetWorkbookQuery({ workbookId, viewId });
  // screenshot
  const [
    screenshotFunction,
    {
      data: screenshotData,
      isLoading: isScreenshotLoading,
      isSuccess: isScreenshotSuccess,
      isError: isScreenshotError,
      error: screenshotError,
    },
  ] = useScreenshotFunctionMutation();
  useEffect(() => {
    if (isScreenshotLoading) {
      setToast({
        message: "screenshot is genrating...., Please do not leave the page",
      });
    }
  }, [isScreenshotLoading]);
  // saveing workbook view
  const [
    saveWorkbookView,
    {
      data: savedWBData,
      isError: isSavedWBError,
      isLoading: isSavedWBLoading,
      isSuccess: isSavedWBSuccess,
      error: savedWBError,
    },
  ] = useSaveWorkbookViewMutation();
  // workbook views with respect to workbookId
  const { data: workbookViewData, refetch } =
    useGetWorkbookViewsByWorkbookIdQuery(workbookId);
  // delete workbook view via viewId
  const [
    deleteWorkbookView,
    {
      data: deleteWorkbookViewData,
      isLoading: isDeletingWBLoading,
      isSuccess: isDeletingWBSuccess,
      isError: isDeletingWBError,
      error: deleteWorkbookViewError,
    },
  ] = useDeleteWorkbookViewMutation();

  const sheetsWithActivity = useSelector(getSheetsWithActiveIndexes);
  const activeSheetId =
    sheetsWithActivity.length === 1 ? sheetsWithActivity[0].Sheetid : null;
  const nonActiveSheetFilters = useSelector((state) =>
    activeSheetFilters(state, activeSheetId)
  );

  const wbCreatedBy =
    workbookData !== undefined
      ? workbookData.createdBy
        ? workbookData.createdBy
        : "createdBy is not existed"
      : "workbook data is undefined";

  const isEditButtonVisible = conditionForEditWB({
    username,
    roles,
    wbCreatedBy,
  });
  const isWBViewButtonVisible = conditionForSavingTheWBView({
    username,
    roles,
    wbCreatedBy,
  });
  useEffect(() => {
    if (workbookData) {
      dispatch(setWorkbookData(workbookData));
      const isValidFilters = Array.isArray(filters) && filters.length;
      if (isValidFilters) {
        const activeSheetId = filters[0]["Sheetid"];
        dispatch(
          setFiltersForScreenshot({
            value: filters,
            activeSheetId,
          })
        );
        dispatch(
          setSheetControls({
            Sheetid: activeSheet?.Sheetid,
            controls: {
              activeIndex: activeSheet?.activeIndex,
              activeBarIndex: activeSheet?.activeBarIndex,
              stackActiveIndex: activeSheet?.stackActiveIndex,
            },
            calledFrom: "vieworkbook 1",
          })
        );
      }
      if (workbookData?.workBookViewActiveSheet) {
        // console.log(workbookData?.workBookViewActiveSheet);

        workbookData.workBookViewActiveSheet.forEach((sheet) => {
          dispatch(
            setSheetControls({
              Sheetid: sheet?.activeSheetId,
              controls: {
                activeIndex: sheet?.activeIndex,
                activeBarIndex: sheet?.activeBarIndex,
                stackActiveIndex: sheet?.stackActiveIndex,
              },
              calledFrom: "vieworkbook 2",
            })
          );
        });
      }
    }
  }, [workbookId, workbookData]);

  useEffect(() => {
    if (workbookData !== undefined) {
      if (workbookData?.parentFolderId) {
        sessionStorage.setItem("folderId", workbookData?.parentFolderId);
      }

      if (sheetId) {
        const sheet = workbookData.sheets.find((sheet) => sheet.ID === sheetId);
        // console.log(sheet);
        if (sheet) {
          if (sheet.sheetType === "dashboard" && sheet.SheetsArray.length) {
            setCurrentSheet({
              Sheetid: sheet.ID,
              SheetName: sheet.SheetName,
              SheetType: sheet.sheetType,
              SheetVizType: sheet.VizType,
              SheetsArray: sheet.SheetsArray,
              SheetsCustomization: sheet.customization,
            });
          } else {
            setCurrentSheet({
              Sheetid: sheet.ID,
              SheetName: sheet.SheetName,
              SheetType: sheet.sheetType,
              SheetVizType: sheet.VizType,
              SheetDataSourceID: sheet.dataSourceID,
            });
          }
        }
      } else {
        // sheetId is undefined or null so selectedSheet
        const selectedSheet = workbookData.sheets.find(
          (sheet) => sheet.ID === sheetId
        );
        setCurrentSheet({
          Sheetid: selectedSheet.ID,
          SheetName: selectedSheet.SheetName,
          SheetType: selectedSheet.sheetType,
          SheetVizType: selectedSheet.VizType,
          SheetDataSourceID: selectedSheet.dataSourceID,
        });
      }
    } else {
      console.error("workbook data is undefined");
    }
  }, [sheetId, workbookData]); // Add necessary dependencies

  const handleEditWorkbook = () => {
    // console.log(workbookData);
    sessionStorage.setItem("workBookId", workbookData.draftId);
    // navigate("/workbook");
    // console.log(workbookData.draftId);
    navigate(`/workbook?workbookid=${workbookData.draftId}`);
  };

  const updateDimensions = () => {
    if (droppableAreaRef.current) {
      const droppableWidth =
        droppableAreaRef.current.getBoundingClientRect().width;
      setGridSize(droppableWidth / GRID_COLUMNS);
    }
  };

  useEffect(() => {
    updateDimensions(); // Initial dimensions
    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [currentSheet, filterSideBar]); // Remove unnecessary dependencies

  if (isWorkbookLoading) {
    return <LoadingIndicator />;
  }
  if (isWorkbookError) {
    console.error(workbookError);
    return (
      <div className="flex items-center justify-start gap-1 text-red-500 text-xl">
        Error: {workbookError.data || "An error occred"}
      </div>
    );
  }
  const currentState = store.getState().Workbook.present;

  const handleSaveWorkbookView = async () => {
    // // console.log(currentState);
    // console.log(sheetsWithActivity);

    if (currentState) {
      const isValidFilters =
        Array.isArray(nonActiveSheetFilters) && nonActiveSheetFilters.length;
      // // console.log(nonActiveSheetFilters);
      const activeSheetArray = Array.isArray(sheetsWithActivity)
        ? sheetsWithActivity.map((s) => {
            return {
              activeSheetId: s.Sheetid,
              activeIndex: s.activeIndex,
              activeBarIndex: s.activeBarIndex,
              stackActiveIndex: s.stackActiveIndex,
              clickedValues: s.clickedValues,
            };
          })
        : [];
      // console.log(activeSheetArray);
      const object = {
        workbookId: currentState["_id"],
        workbookObject: currentState,
        activeFilters: isValidFilters ? nonActiveSheetFilters : [],
        activeSheet: activeSheetArray,
      };
      // console.log(object);

      try {
        const response = await saveWorkbookView(object);
        // console.log(response?.data?.message);
        refetch();
      } catch (error) {
        console.error("Error during saving the view:", error);
      }
    }
  };

  const workBokViewsArray =
    Array.isArray(workbookViewData["workbookViews"]) &&
    workbookViewData["workbookViews"].length
      ? workbookViewData["workbookViews"]
      : [];

  const handleWorkBookView = (viewObject) => {
    // console.log(viewObject);
    if (viewObject) {
      navigate(
        `/dashboard?workbookid=${viewObject?.originalWorkBookId}&sheetid=${viewObject?.selectedSheetId}&viewid=${viewObject?._id}`
      );
    } else {
      console.error("error while workbook view");
    }
  };
  // // console.log(isWorkbookSuccess);

  return isWorkbookSuccess && currentSheet !== null ? (
    <>
      <main className="overscroll-hidden w-full h-screen">
        {/* header */}
        <section className="flex items-center justify-between px-3 border-b-2  py-2 z-10 h-[5%]">
          {isEmbed ? null : (
            <div className="flex items-center justify-center gap-2">
              <button
                className="flex items-center justify-start gap-1"
                onClick={() => navigate("/home/dash")}
              >
                <ImHome />
              </button>
              <LibraryFolderPaths isFolderPresentInLibrary={false} />
            </div>
          )}
          <div className="font-medium tracking-wide">{workbookData.name}</div>
          {isEmbed ? null : (
            <div className="flex items-center justify-center gap-3">
              {isWBViewButtonVisible ? (
                <div className="w-auto min-w-48 text-[14px] border-blue-950 tracking-wide flex flex-col gap-2 justify-between items-center border  text-blue-950 relative">
                  <div className="w-full flex items-center justify-between gap-2">
                    <button
                      className="w-auto text-[14px] tracking-wide flex gap-2 justify-between items-center px-[6px] "
                      onClick={handleSaveWorkbookView}
                    >
                      {" "}
                      <AiOutlineSave />
                      {isSavedWBLoading ? "Saving..." : "Save"}
                    </button>
                    <button
                      onClick={() =>
                        setViewPublishedButton(!viewPublishedButton)
                      }
                      className="text-center w-auto"
                    >
                      {!viewPublishedButton ? (
                        <IoMdArrowDropdown className="text-xl text-center text-blue-950 border-l border-blue-950 cursor-pointer" />
                      ) : (
                        <IoMdArrowDropup className="text-xl text-center text-blue-950 border-l border-blue-950 cursor-pointer" />
                      )}
                    </button>
                  </div>
                  {viewPublishedButton ? (
                    <div
                      className={`w-auto flex flex-col items-start justify-start gap-1 ${
                        viewPublishedButton.length > 9 ? "h-40" : "h-auto"
                      } overflow-y-auto absolute top-full left-[0] right-0 bg-white shadow-md mt-1 z-30 text-xs`}
                    >
                      {workBokViewsArray.map((view) => (
                        <div className="flex items-center justify-start gap-2 w-full h-full">
                          <button
                            onClick={() => handleWorkBookView(view)}
                            className="py-1 px-2 hover:bg-gray-100 text-left"
                          >
                            {view.workBookViewName}
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : null}
              <button
                className="flex items-center gap-2 border border-blue-950 px-2 text-xs py-[2px] text-blue-950"
                onClick={() => setSubscribeModal(true)}
              >
                Subscribe
              </button>
              {isEditButtonVisible ? (
                <button
                  className="flex items-center gap-2 border border-blue-950 px-2 text-xs py-[2px] text-blue-950"
                  onClick={handleEditWorkbook}
                >
                  Edit
                </button>
              ) : null}
              <Dropdown
                label={
                  <button className="text-black flex items-center  justify-between w-28 max-w-32 truncate border border-blue-950 bg-transparent px-1 text-xs">
                    <span className="flex items-center justify-start gap-2">
                      <MdDownload className="text-blue-950" /> Download
                    </span>
                    <IoMdArrowDropdown className="text-xl text-black" />
                  </button>
                }
                arrowIcon={false}
                dismissOnClick={true}
                className="shadow-lg"
              >
                <Dropdown.Item
                  className="flex gap-2 w-full items-center justify-start px-2"
                  onClick={() => {
                    currentSheet.SheetType === "dashboard"
                      ? handleDownloadDataModal(sheetId)
                      : handleCallFunction(sheetId, "csv");
                  }}
                >
                  <GrDocumentCsv /> .csv
                </Dropdown.Item>
                <Dropdown.Item
                  className="flex gap-2 w-full items-center justify-start px-2"
                  onClick={() =>
                    currentSheet.SheetType === "dashboard"
                      ? takeAndDownloadScreenshotForRechart(
                          screenshotFunction,
                          sheetId,
                          "jpg",
                          workbookId,
                          currentSheet?.SheetType,
                          nonActiveSheetFilters,
                          sheetsWithActivity,
                          currentState
                        )
                      : handleCallFunction(sheetId, "image", "jpg")
                  }
                >
                  <FaRegFileImage /> as image
                </Dropdown.Item>
                <Dropdown.Item
                  className="flex gap-2 w-full items-center justify-start px-2"
                  onClick={() =>
                    currentSheet.SheetType === "dashboard"
                      ? takeAndDownloadScreenshotForRechart(
                          screenshotFunction,
                          sheetId,
                          "pdf",
                          workbookId,
                          currentSheet?.SheetType,
                          nonActiveSheetFilters,
                          sheetsWithActivity,
                          currentState
                        )
                      : handleCallFunction(sheetId, "image", "pdf")
                  }
                >
                  <GrDocumentPdf /> as pdf
                </Dropdown.Item>
              </Dropdown>
              <DropDownComp />
            </div>
          )}
        </section>

        {/* body */}
        <ViewworkbookHeader2
          workbookData={workbookData}
          workbookId={workbookId}
          sheetId={sheetId}
          isEmbed={isEmbed}
        />

        {/* charts of view workbook */}
        <ViewWBCharts
          droppableAreaRef={droppableAreaRef}
          gridSize={gridSize}
          currentSheet={currentSheet}
          itemRef={itemRef}
          snapToGrid={snapToGrid}
          buttonRef={buttonRef}
          setFilterSideBar={setFilterSideBar}
          filterSideBar={filterSideBar}
          sheetId={sheetId}
          filters={filters}
          screenshotFunction={screenshotFunction}
          animationOff={animationOff}
        />
      </main>

      {/* Subscribe Modal */}
      {subscribeModal && (
        <SubscribeModal
          closeModal={() => setSubscribeModal(false)}
          sheetId={sheetId}
          workbookId={workbookId}
          currentSheetType={currentSheet.SheetType}
        />
      )}
      {/* Download Data Modal */}
      {workbookData !== undefined && downloadDataModal && (
        <DownloadDataModal
          closeModal={() => setDownloadDataModal(false)}
          workbookData={workbookData}
          sheetId={sheetId}
        />
      )}
    </>
  ) : (
    <button
      className="flex items-center justify-start gap-1 text-red-500 text-xl"
      onClick={() => navigate(-1)}
    >
      <IoArrowBackOutline />
      Sheet Doesn't Exist
    </button>
  );
}
